import { render, staticRenderFns } from "./companies.vue?vue&type=template&id=7b5d4db9"
import script from "./companies?vue&type=script&lang=js&external"
export * from "./companies?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports